var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-date"},[_c('input',{ref:"datepickerElement",attrs:{"type":"text"},domProps:{"value":_vm.$formatter.date(_vm.value)}}),_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }